
import React from 'react';
import { CheckCircle } from 'lucide-react';
import { SubscriptionPlan } from '@/types/subscriptionPlans';
import { PlanType } from '@/hooks/useAdminPlans';

interface OrderSummaryProps {
  selectedPlan: SubscriptionPlan;
  selectedPlanType: PlanType;
  getPrice: () => number;
}

const OrderSummary: React.FC<OrderSummaryProps> = ({
  selectedPlan,
  selectedPlanType,
  getPrice,
}) => {
  return (
    <div className="bg-blue-50 p-4 rounded-md">
      <h3 className="text-lg font-medium mb-3">Order Summary</h3>
      <div className="space-y-2 mb-4">
        <div className="flex justify-between">
          <span className="text-sm text-gray-600">Plan:</span>
          <span className="font-medium">{selectedPlan.name}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-sm text-gray-600">Billing:</span>
          <span className="font-medium capitalize">{selectedPlanType}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-sm text-gray-600">Price:</span>
          <span className="font-medium">${getPrice()}</span>
        </div>
        <div className="border-t border-gray-200 my-2 pt-2">
          <div className="flex justify-between font-medium">
            <span>Total:</span>
            <span>${getPrice()}</span>
          </div>
        </div>
      </div>
      <div className="space-y-1">
        <div className="flex items-start">
          <CheckCircle className="h-4 w-4 text-green-500 mr-2 mt-0.5" />
          <span className="text-xs">Up to {selectedPlan.maxReferrals} referrals</span>
        </div>
        <div className="flex items-start">
          <CheckCircle className="h-4 w-4 text-green-500 mr-2 mt-0.5" />
          <span className="text-xs">Up to {selectedPlan.maxManagers} managers</span>
        </div>
      </div>
    </div>
  );
};

export default OrderSummary;
